import { render, staticRenderFns } from "./CadastroConfiguracaoFreteCepList.vue?vue&type=template&id=cba0c9c2"
import script from "./CadastroConfiguracaoFreteCepList.vue?vue&type=script&lang=js"
export * from "./CadastroConfiguracaoFreteCepList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports